import { atom } from "recoil";

import { PermissionDto } from "../../../dto";

export const permissionsAtom = atom<PermissionDto[] | undefined>({
  key: "permissionAtom",
  default: undefined,
});
